module.exports = __webpack_public_path__ + "1dc35d25e61d819a9c357074014867ab.ttf";


//////////////////
// WEBPACK FOOTER
// ./theme/fonts/fontawesome-webfont.ttf?v=4.6.3
// module id = 87
// module chunks = 0